export const PACKAGE_NAMES = ['Starter', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'];
export const PACKAGE_PRICES = [10, 20, 30, 70, 120, 250];

export const POOL_NAMES = ['Gold', 'Platinum', 'Diamond', 'Crown', 'Blue', 'Ambassador'];
export const POOL_COLORS = ['#FFD700', '#E5E4E2', '#B9F2FF', '#FF6B35', '#3B82F6', '#7B61FF'];
export const POOL_PERCENTAGES = [3, 3, 4, 2, 4, 4];

export const LEVEL_INCOME_PERCENT = 2.5;
export const SPONSOR_INCOME_PERCENT = 50;
export const TOTAL_MATRIX_LEVELS = 12;
